import React from 'react';

const SystemMessage = React.memo(({ message }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    margin: '8px 0'
  }}>
    <span style={{
      fontFamily: 'Poppins',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '1.5em',
      color: '#667085',
      textAlign: 'center'
    }}>
      {message}
    </span>
  </div>
));

SystemMessage.displayName = 'SystemMessage';

export default SystemMessage;
